import React from 'react'
import { BsCaretRight } from 'react-icons/bs'
import styles from '../componentsStyles/Docs.module.css'

const Larea = () => {
  return (
    <>
      <div className={styles.sticky}>
        <div className={styles.lareaSection}>
            <input type="checkbox" id='doc-cb' className={styles.dcb}/>
            <label htmlFor="doc-cb"> Topics <BsCaretRight className={styles.icon}/> </label>
            
              <div className={styles.lareaWrapper}>
                <div>
                  <div className={styles.lareaText}>
                      <a href='/docs#doc-starting'> How the start?       </a>
                      <a href='/docs#doc-briefing'> Project briefing     </a>
                      <a href='/docs#doc-tools'> Chosing the rigth tools </a>
                      <a href='/docs#doc-finishing'> Contract fullfiled  </a>
                      <a href="/docs#doc-scaling"> Scaling</a>
                  </div>
                </div>

            </div>
        </div>
      </div>
        

    </>
  )
}

export default Larea